import React from "react";
import { MapPin } from "lucide-react";
import { SERVICE_AREAS, IMAGES } from "@/data/content";

export const ServiceArea = () => {
  return (
    <section id="area" data-testid="area-section" className="relative">
      <div className="absolute inset-0">
        <img src={IMAGES.area} alt="Phoenix Arizona skyline" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A0A0A]/85" />
      </div>

      <div className="relative container mx-auto px-6 md:px-12 max-w-7xl py-24 md:py-32">
        <div className="max-w-3xl">
          <p className="text-sm uppercase tracking-[0.2em] font-bold text-[#D86C1E] mb-4">
            Where We Work
          </p>
          <h2 className="font-heading text-4xl sm:text-5xl font-black tracking-tight leading-tight text-white">
            Serving All of Arizona &amp; Beyond
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-white/70">
            Headquartered in Phoenix, Schuyler proudly covers the entire Valley and surrounding
            communities. If you've got a roof in Arizona, you've got a roofer.
          </p>
        </div>

        <div className="mt-12 flex flex-wrap gap-3">
          {SERVICE_AREAS.map((a) => (
            <span
              key={a}
              data-testid={`area-${a.toLowerCase().replace(/\s/g, "-")}`}
              className="inline-flex items-center gap-2 border border-white/20 bg-white/5 backdrop-blur-sm text-white px-4 py-2 text-sm font-medium hover:border-[#D86C1E] hover:bg-[#D86C1E]/10 transition-colors"
            >
              <MapPin className="h-3.5 w-3.5 text-[#D86C1E]" />
              {a}
            </span>
          ))}
          <span className="inline-flex items-center gap-2 bg-[#D86C1E] text-white px-4 py-2 text-sm font-bold uppercase tracking-wide">
            + Surrounding Areas
          </span>
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;
